import { INITIAL_STATE } from '../core'

import {
    SET_BOOTSTRAPPED,
} from '../action_creators'

function bootstrapped(state=INITIAL_STATE.bootstrapped, action) {
    switch (action.type) {
        case SET_BOOTSTRAPPED:
            return action.bootstrapped
        default:
            return state
    }
}

export default bootstrapped


// WEBPACK FOOTER //
// ./src/redux/reducers/bootstrapped_reducer.js